
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useMatomoPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['trackPageView']);
    }
  }, [location]);
};

export default useMatomoPageTracking;
